import ContactService from '@/services/ContactService';
import PrisonService from '@/services/PrisonService';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    stage: 1,
    contacts: [],
    lastSlotDate: null,
    slots: [],
    booking: {
      contact: null, // visitor
      wing: null,
      bookingSlot: null,
      date: '',
    },
  },
  getters: {},
  mutations: {
    SET_CONTACTS(state, contacts) {
      state.contacts = contacts;
    },
    SET_CONTACT(state, contact) {
      state.booking.contact = contact;
    },
    SET_WING(state, wing) {
      state.booking.wing = wing;
    },
    SET_BOOKING_SLOT(state, slot) {
      state.booking.bookingSlot = slot;
    },
    SET_BOOKING_DATE(state, date) {
      state.booking.date = date;
    },
    SET_STAGE(state, value) {
      state.stage = value;
    },
    SET_SLOTS(state, value) {
      state.slots = value;
    },
    SET_LAST_SLOT_DATE(state, value) {
      state.lastSlotDate = value;
    },
  },
  actions: {
    refreshContacts({ commit }) {
      return ContactService.getContacts().then(res => {
        commit('SET_CONTACTS', res.data);
      }).catch(() => {
        Vue.$toast.error('Could not get your contacts, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    getSlots({ commit, state, rootState }) {
      if (state.booking.wing) {
        // eslint-disable-next-line no-underscore-dangle
        return PrisonService.getBookingSlotAvailabilityForWing(rootState.auth.prison.prison_id, state.booking.wing._id).then(res => {
          commit('SET_SLOTS', res.data);
          commit('SET_LAST_SLOT_DATE', PrisonService.getLastDateFromBookingSlot(res.data));
        });
      }

      return PrisonService.getBookingSlotAvailability(rootState.auth.prison.prison_id).then(res => {
        commit('SET_SLOTS', res.data);
        commit('SET_LAST_SLOT_DATE', PrisonService.getLastDateFromBookingSlot(res.data));
      });
    },
    reset({ commit }) {
      commit('SET_CONTACT', null);
      commit('SET_WING', null);
      commit('SET_BOOKING_DATE', '');
      commit('SET_BOOKING_SLOT', null);
    },
  },
};
